import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "../lib/api";
import { Logo } from "../components/Logo";
import NoIndex from "../components/NoIndex";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      return;
    }
    api
      .post(`/auth/verify-email/${token}`)
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <NoIndex />
      <div className="w-full max-w-sm text-center">
        <div className="mb-8 flex items-center justify-center">
          <Logo className="h-8" />
        </div>
        {status === "verifying" && (
          <div data-testid="verify-email-loading">
            <Loader2 className="mx-auto h-8 w-8 animate-spin text-primary" />
            <p className="mt-3 text-sm text-muted-foreground">Verifying your email...</p>
          </div>
        )}
        {status === "success" && (
          <div data-testid="verify-email-success">
            <CheckCircle2 className="mx-auto h-10 w-10 text-emerald-500" />
            <h1 className="mt-4 font-heading text-xl font-bold">Email verified!</h1>
            <p className="mt-1 text-sm text-muted-foreground">Your account is now fully active.</p>
            <Link to="/" className="mt-6 inline-block font-medium text-primary hover:underline">
              Go to Dashboard
            </Link>
          </div>
        )}
        {status === "error" && (
          <div data-testid="verify-email-error">
            <XCircle className="mx-auto h-10 w-10 text-destructive" />
            <h1 className="mt-4 font-heading text-xl font-bold">Verification failed</h1>
            <p className="mt-1 text-sm text-muted-foreground">This link is invalid or has expired. Log in and resend a new one.</p>
            <Link to="/login" className="mt-6 inline-block font-medium text-primary hover:underline">
              Go to Login
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
